<style>
  @import "./account.scss";
</style>

<script>

import { BTabs, BTab } from 'bootstrap-vue'
import ConsumerLogin from './consumer-login/consumer-login'
import AdminLogin from './admin-login/admin-login'
import ConsumerRegister from './consumer-register/consumer-register'
import { mapGetters } from 'vuex'
import { EventBus } from '@/event-bus'
import ConsumerLogout from './consumer-logout/consumer-logout'
import ProfileManagement from './profile-management/profile-management'
import ConsumerForgetPwd from './consumer-forget-pwd/consumer-forget-pwd'

export default {
  name: 'MyAccount',

  components: {
    ConsumerForgetPwd,
    AdminLogin,
    ConsumerLogin,
    BTabs,
    ConsumerRegister,
    ConsumerLogout,
    BTab,
    ProfileManagement
  },

  data () {
    return {
      currentScreen: 'consumerLogin'
    }
  },

  computed: {
    ...mapGetters(['consumerJwt', 'accountType'])
  },

  mounted () {
    EventBus.$on('switchConsumerPage', (pageName) => {
      this.currentScreen = pageName
    })
  },

  methods: {
    /**
     * This method will set the default screen
     */
    setDefaultScreen () {
      this.currentScreen = 'consumerLogin'
    }
  }
}
</script>

<template>
  <div
    id="config-account"
    class="container container-height pb-5"
  >
    <div v-if="accountType === 'profile'">
      <profile-management/>
    </div>
    <div v-else>
      <div
        class="mt-4">
        <h3>
          {{ $t ('header.login') }}
        </h3>
      </div>
      <div class="border-dark border-top my-2" />
      <div
        class="col-md-6 col-sm-12 mx-auto mt-3">
        <b-tabs
          content-class="content-wrapper"
          nav-class="account-tabs border-primary"
          justified
        >
          <b-tab
            title="Admin Login"
          >
            <admin-login />
          </b-tab>
          <b-tab
            active
            title = "Consumer Login"
            @click = "setDefaultScreen()">
            <div
              v-if="!consumerJwt">
              <consumer-login v-if="currentScreen === 'consumerLogin'" />
              <consumer-register v-if="currentScreen === 'consumerRegister'" />
              <consumer-forget-pwd v-if="currentScreen === 'forgetPwd'" />
            </div>
            <div v-if="consumerJwt">
              <consumer-logout/>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
